// OTA Ticket Types - must match backend ticket_type.rs constants
export const OTA_TICKET_TYPES = ['OTA Reservation', 'OTA Support', 'OTA Inquiry'] as const

export type OtaTicketType = (typeof OTA_TICKET_TYPES)[number]
